// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"247":"c40f87f7","992":"55185b83"}[chunkId] + ".chunk.js");